var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",style:({ width: _vm.width })},[_c('img',{staticClass:"logo__img",attrs:{"src":require("../../assets/logo.png"),"alt":"Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }